import React from 'react';
import { Alert, Box, themes } from '@digitools/honest-react';
import { useTranslation } from 'react-i18next';
import useAuthentication from '../../../../../hooks/useAuthentication';
import titleCase from 'status/utilities/titleCase';
import formatPhone from 'status/utilities/formatPhone';
const Error = ({ error, notFound }) => {
    const noData = notFound || (error.response && error.response.status === 404);
    if (noData) {
        return <></>;
    }
    else {
        return (<Alert type={'error'}>
        <span>
          <strong>Error!</strong>&nbsp;Unable to load leave specialist.
        </span>
      </Alert>);
    }
};
const LeaveSpecialist = ({ specialistName, leaveNum, employeeName, leavePhone, leaveEmail, leaveFax, leaveOfficeName, leaveAddress, leaveCity, leaveState, leaveZip }) => {
    const { t } = useTranslation();
    const { user } = useAuthentication();
    const emailRegex = RegExp(/^$|^[A-Za-z0-9\._%-]+@[A-Za-z0-9\.-]+\.[A-Za-z]{2,4}$/);
    const leaveNumRegex = RegExp(/^\d+$/);
    const specialistFirstName = specialistName ? specialistName.split(' ')[0] : '';
    const specialistLastName = specialistName ? specialistName.split(' ')[1] : '';
    return (<div className='mb-3'>
      <Box type='header' style={{ border: `1px solid ${themes.rebrand.palette.grayLighter}` }}>
        {t('leaveSpecialistText')}
      </Box>
      <Box style={{ wordWrap: 'break-word', border: `1px solid ${themes.rebrand.palette.grayLighter}` }}>
        <small data-private={true} className='d-block'>
          {titleCase(specialistFirstName)} {titleCase(specialistLastName)}
        </small>
        <small className='d-block'>{leaveOfficeName || ""}</small>
        <small className='d-block'>{leaveAddress || ""}</small>
          <small className='d-block'>
            {`${leaveCity || ""}, ${leaveState || ""} ${leaveZip || ""}`}
          </small>
          <small className='d-block'>
            <strong>{t('phoneText')}: </strong> {formatPhone(leavePhone)}
          </small>
        
        {leaveEmail && emailRegex.test(leaveEmail) && leaveNumRegex.test(leaveNum) &&
            <small className='d-block'>
            <strong>Email: </strong>{' '}
              <a href={`mailto:${leaveEmail}?subject=${employeeName} %23${leaveNum}`}>
                {leaveEmail}
              </a>
          </small>}
        {leaveFax &&
            <small className='d-block'>
            <strong>{t('faxText')}: </strong> {formatPhone(leaveFax)}
          </small>}
      
      </Box>
    </div>);
};
export default LeaveSpecialist;
